module.exports = __webpack_public_path__ + "media/04experience.18b49a45.mp3";